<template>

<app-view-sheet-field align="center" :is-sticky="isSticky" :field="field" :filter="filter">

    <core-date :date="value" :is-plain="true" invalid="" />

</app-view-sheet-field>

</template>

<script>

export default {

	props: ['field', 'filter', 'item', 'isSticky'],

	computed: {

		value: function() {

			return this.item.rating.date

		}

	}

}

</script>

<style scoped>

</style>